import './DetailedProject.css';
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import DetailDescription from "../components/DetailDescription";
import NoPageFound from "./NoPageFound";
import React from "react";

function DetailedProject() {
    const params = useParams();
    const projs = useSelector(state => state.project.projects);
    
    const project = projs.find(pro => pro.id === params.projId);

    if (!project) {
        return <NoPageFound />;
    }

    return(
        <div id='detail-body-project'>
            <div className='top-detail'>
                <img className="detail-proj-img" alt="project" loading="lazy" src={project.image} />
                <div id="right-detail">
                    <h4 id='proj-detail-name'>{project.name}</h4>
                    <div id='used-technology'>
                        <p id='proj-detail-technologies'>Technologies used:</p>
                        <div id='technology-list'>
                            {project.technologies}
                        </div>
                    </div>
                </div>
            </div>

            <DetailDescription content={project.description} />

            {project.gitLink && project.gitLink !== "" && (
                <a style={{alignSelf: "center", textAlign: "center", marginTop: "3rem"}} target="_blank" href={project.gitLink} rel="noreferrer">
                    <img style={{width: "200px", maxWidth: "100%"}} src={require("../images/GitHub_Logo_White.png")} alt="Github"/>
                </a>
            )}
            
        </div>
    )
}

export default DetailedProject;